<template>
  <div class="campaigns-edit-step-social-menu">
    <span v-for="item in items" :key="item.name">
      <social-step-editor-menu-item
        :item="item"
        :active="activeItem.name === item.name"
        :disabled-items="disabledItems"
        @clicked="$emit('clicked', item.name)"
      />
    </span>
  </div>
</template>

<script>
import SocialStepEditorMenuItem from './SocialStepEditorMenuItem';

export default {
  components: {SocialStepEditorMenuItem},
  props: {
    items: Array,
    activeItem: Object,
    disabledItems: Array,
  },
  methods: {
    onUpdate(item) {
      this.$emit('update', item);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../../sass/web/_variables.scss';

.campaigns-edit-step-social-menu {
  background: $color-aqua-haze;
}
</style>
